import clsx from "clsx";
import React, {FunctionComponent, useEffect, useState} from "react";
import Icon from "../icon/Icon";
import InputText, {InputTextProps} from "./InputText";
import {Action} from "../../../utils/Action";

export type SearchBarProps = Omit<InputTextProps, "autoComplete">;

const SearchBar: FunctionComponent<SearchBarProps> = ({value, onChange, cssClass, ...inputAttr}) => {
    const [query, setQuery] = useState<string>("");

    const handleChangeQuery = (query: string) => {
        setQuery(query);
        onChange(query);
    };

    useEffect(() => {
        setQuery(value || "");
    }, [value]);

    return (
        <div className={clsx("search-bar", cssClass)}>
            <Icon {...Action.SEARCH.icon} cssClass={"search-bar__icon"}/>
            <InputText
                value={query}
                onChange={handleChangeQuery}
                autoComplete={"off"}
                {...inputAttr}
            />
        </div>
    );
};

export default SearchBar;
